module.exports = __webpack_public_path__ + "assets/img/news (24).922911bc.png";